export default "__VITE_ASSET__D67WJrW0__"